import { render, staticRenderFns } from "./ToggleView.vue?vue&type=template&id=aea27bcc&scoped=true&"
import script from "./ToggleView.vue?vue&type=script&lang=js&"
export * from "./ToggleView.vue?vue&type=script&lang=js&"
import style0 from "./ToggleView.vue?vue&type=style&index=0&id=aea27bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea27bcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
